export const filterOptions = (options, input) => {
    /**
     * Return all options when input is empty
     */
    if (!input)
        return options;
    return options.filter(option => {
        const label = option.label.toLowerCase();
        const value = option.value.toLowerCase();
        /**
         * Return all options matching `label` or `value`
         */
        return (value.indexOf(input.toLowerCase()) > -1 ||
            label.indexOf(input.toLowerCase()) > -1);
    });
};
export const containsNode = (parent, child) => {
    return child && parent && parent.contains(child);
};
